import { Header } from 'semantic-ui-react';
import { ProjectAutopricing } from '~/constants';
import { Project } from '~/types/project';
import PricingEstimateButton from '../PricingEstimate/PricingEstimateButton';
import { usePermissions } from '~/requests/permissions/usePermissions';
import PricingEstimateTooltip from './PricingEstimateTooltip';
import { ReactComponent as ConductorLogo } from '~/assets/logo.svg';


interface PricingEstimateProps {
  project: Project;
  projectAutopricing: any
  isEpcOperating?: boolean;
  projectState: any;
  projectErrors?: any;
}

export default function PricingEstimate({
  project,
  projectAutopricing,
  isEpcOperating,
  projectState,
  projectErrors
}: PricingEstimateProps) {
  const { permissions } = usePermissions();

  const autopricing = ProjectAutopricing[project?.pricingType]
    ?.filter(({ valueKey }: { valueKey: string }) => {
      return projectAutopricing?.autopricingResult?.[valueKey] !== undefined;
    });

  return (
    <div>
      <Header as="h2">
        Pricing estimate
        <PricingEstimateTooltip />
      </Header>
      <p style={{marginTop: '-12px', marginBottom: '20px'}}>Pricing estimate is only visible to your team.</p>
      <div className="pricing-estimate">
        {projectAutopricing?.conditions?.hasPricingEstimate ? (
          autopricing?.map(({ label, valueKey }: { label: string, valueKey: string }, i: number) => (
            <div key={`${project?.pricingType}-${label}`} className="estimate-item">
              <span className="estimate-value">{projectAutopricing?.autopricingResult?.[valueKey]}</span>
              <span className="estimate-label">{ 
                isEpcOperating && i === 0 ? 'Project acquisition' : (
                  (project?.pricingType === 'DEV_FEE' && i === 0) ? 'Development fee' : label
                )}</span>
            </div>
          ))
        ) : (
          <div className="no-pricing-estimate">
            <p style={{marginBottom: '24px'}}>
              No pricing estimate has been generated for this project.
            </p>
          </div>
        )}
        <PricingEstimateButton project={project} projectState={projectState} errors={projectErrors} />
        {permissions.isAdmin && project?.autopricingResult?.spreadsheetUrl && (
          <div className="admin-spreadsheet-link" style={{ marginTop: '12px', marginBottom: '12px', fontSize: '14px' }}>
            <a
              href={project.autopricingResult.spreadsheetUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              View pricing spreadsheet
            </a>
          </div>
        )}
        <div className="powered-by">
          <span>Powered by</span> <ConductorLogo />
        </div>
      </div>
    </div>
  );
};